import axios from "axios";
import { firebaseBase } from "../constants/dbConstants"

export async function getQuestionaryByName(questionaryId, token) {
  const response = await axios.get(
    `${firebaseBase}/Questionaries/${questionaryId}/sections.json?auth=${token}`
  );
  return response;
}
